'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_crud$Close$() {
}
export { $c_Lpresto_crud$Close$ as $c_Lpresto_crud$Close$ };
$p = $c_Lpresto_crud$Close$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_crud$Close$;
/** @constructor */
function $h_Lpresto_crud$Close$() {
}
export { $h_Lpresto_crud$Close$ as $h_Lpresto_crud$Close$ };
$h_Lpresto_crud$Close$.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return 65203672;
});
$p.l = (function() {
  return "Close";
});
$p.r = (function() {
  return 0;
});
$p.s = (function() {
  return "Close";
});
$p.j = (function(n) {
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_Lpresto_crud$Close$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_crud$Close$, "presto.crud$Close$", ({
  Vq: 1,
  ca: 1,
  b: 1,
  c: 1,
  a: 1,
  e: 1,
  g: 1,
  m: 1
}));
export { $d_Lpresto_crud$Close$ as $d_Lpresto_crud$Close$ };
var $n_Lpresto_crud$Close$;
function $m_Lpresto_crud$Close$() {
  if ((!$n_Lpresto_crud$Close$)) {
    $n_Lpresto_crud$Close$ = new $c_Lpresto_crud$Close$();
  }
  return $n_Lpresto_crud$Close$;
}
export { $m_Lpresto_crud$Close$ as $m_Lpresto_crud$Close$ };
//# sourceMappingURL=presto.crud$-Close$.js.map
